import { useAppData } from '../context/AppDataContext';

/**
 * useGatewaysOptimized — now a thin wrapper around the global AppDataContext.
 *
 * Previously this hook ran an N+1 query explosion (35+ queries for 7 gateways)
 * on every page mount. Now it reads from the shared cache.
 *
 * API is unchanged so existing pages don't need modifications.
 */
export const useGatewaysOptimized = () => {
  const { gateways, gatewaysCount, gatewaysLoading, gatewaysError, refreshGateways } = useAppData();

  return {
    gateways,
    gatewaysCount,
    isLoading: gatewaysLoading,
    error: gatewaysError,
    refetch: refreshGateways,
  };
};

export default useGatewaysOptimized;
